export default "__VITE_ASSET__COUNPz2t__"